<template>
  <section>
    <div class="z-card z-card--info mb-4">
      <p>{{ $t('db.import.create.description') }}</p>
      <!--<template v-if="recipents_count">
        <p>{{ $t('db.import.create.count', { count: recipents_count }) }}</p>
      </template> -->

      <div class="d-flex mt-3 align-items-center">
        <tooltip
          placement="top"
          min-width="200"
          max-width="200"
          theme="light"
          :content="
            $t('db.import.tooltip.header')
          "
        >
          <i-button
            class="mr-3"
            type="primary"
            html-type="button"
            :disabled="disabled_send"
            @click="save_import"
          >
            {{ $t('db.import.create.button.upload_data') }}
          </i-button>
        </tooltip>

        <checkbox v-model="ignore_header" class="m-0" type="warning" :border="true">
          {{ $t('db.import.create.button.ignore_header') }}
        </checkbox>
      </div>
    </div>

    <z-table
      :fields="fields"
      :items="items"
      :show_per_page="false"
      :show_pagination_description="false"
      class="table--content-middle"
    >
      <template v-for="f in fields" v-slot:[get_head_slot_name(f.key)]>
        <i-select :key="f.key" v-model="relation_columns[f.key]" :clearable="true" :transfer="true">
          <i-option
            v-for="field in recipient_fields"
            :key="field.key"
            :label="field.value"
            :value="field.key"
            :disabled="field.disabled"
          />
        </i-select>
      </template>
    </z-table>
  </section>
</template>

<script>
  import invert from 'lodash-es/invert';
  import { mapGetters } from 'vuex';
  import { RecipientService } from '@db/services/RecipientService';

  export default {
    data: () => ({
      recipents_count: 0,
      fields: [],
      items: [],
      relation_columns: {},
      ignore_header: false
    }),

    computed: {
      ...mapGetters('db/databases/import/recipients', ['getImportFields', 'getImportFieldsTotal']),

      disabled_send() {
        if (
          Object.values(this.relation_columns).includes('number') &&
          Object.keys(this.relation_columns).length > 0
        )
          return false;

        return true;
      },

      recipient_fields() {
        const field_keys = Object.keys(this.$t('db.recipient.field'));
        const selected_keys = Object.values(this.relation_columns);

        return field_keys.map((i) => ({
          key: i,
          value: this.$t(`db.recipient.field.${i}`),
          disabled: selected_keys.includes(i)
        }));
      }
    },

    created() {
      this.set_items(this.getImportFields);
      this.set_fields(this.getImportFields[0].length);
      this.recipents_count = this.getImportFieldsTotal;
    },

    methods: {
      save_import() {
        const col = invert(this.relation_columns);
        const ignore_header = this.ignore_header;
        const { database_id, file_id } = this.$route.params;
        let columns = {};

        Object.keys(col).forEach((key) => {
          columns[key] = Number(col[key]) + 1;
        });

        RecipientService.saveImport(database_id, file_id, { columns, ignore_header })
          .then(() => {
            this.$router.push({ name: 'db.database.index' });
          })
          .catch((error) => {
            this.$noty.server_error(error);
          });
      },

      is_selected(key) {
        const field = this.relation_columns[key];
        if (field) {
          const used_field_keys = Object.values(this.relation_columns);
          return used_field_keys.includes(field);
        }
        return false;
      },

      set_fields(count) {
        this.fields = this.create_fields(count) || [];
      },

      create_fields(count) {
        const fields = [];
        for (let i = 0; i < count; i++) {
          fields.push({
            key: i.toString(),
            sortable: false
          });
        }
        return fields;
      },

      set_items(items) {
        this.items = this.create_items(items) || [];
      },

      create_items(items) {
        return items.map((row) => {
          return { ...row };
        });
      },

      get_head_slot_name(key) {
        return `head_${key}`;
      }
    }
  };
</script>
